import { IShip } from '../../../data/types/ship/ship';
import { getShipConfig } from '../../../config/ship/get-ship-config';

export const getPossibleFuelAmountToPurchase = (
  ship: IShip,
  credits: number,
): number => Math.floor(credits / getShipConfig(ship).costOfFuel);
